import { createContext, useContext, useEffect, useState } from 'react';

import * as TestTrack from '@betterment-oss/test-track';

export interface FeatureFlagConfig {
  splitName: string;
  context: string;
  trueVariant?: string;
}

type StubsValue = Record<string, boolean>;
const StubsContext = createContext<StubsValue | null>(null);

function isStubEnabled(stubs: StubsValue, splitName: string) {
  const isEnabled = stubs[splitName];

  if (typeof isEnabled !== 'boolean') {
    throw new Error(`Split '${splitName}' is not registered`);
  }

  return isEnabled;
}

export const StubFeatureFlags = StubsContext.Provider;

export const useFeatureFlag = ({ splitName, context, trueVariant }: FeatureFlagConfig) => {
  const stubs = useContext(StubsContext);

  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (stubs) {
      setIsEnabled(isStubEnabled(stubs, splitName));
      setIsLoading(false);
      return;
    }

    void TestTrack.ab(splitName, {
      context,
      trueVariant,
      callback: (flagEnabled: boolean) => {
        setIsEnabled(flagEnabled);
        setIsLoading(false);
      },
    });
  }, [context, splitName, trueVariant, stubs]);

  return { enabled: isEnabled, loading: isLoading };
};
